import { useQuery } from "@tanstack/react-query";

import { guacHttpClient } from "@/lib/http";
import { HttpResponse, LinkedJobResponse } from "@/types";

export const linkedJobsQueryKey = (jobId: string) => ["job-links", jobId];

export function useGetLinkedJobs(
  jobId: string,
  { enabled = true }: { enabled?: boolean } = {},
) {
  return useQuery({
    enabled,
    queryKey: linkedJobsQueryKey(jobId),
    queryFn: async () => {
      const path = `jobs/${jobId}/links`;
      const res = await guacHttpClient.get<
        LinkedJobResponse[],
        HttpResponse<LinkedJobResponse[]>
      >(path);
      return res.data;
    },
  });
}
